// extracted by mini-css-extract-plugin
module.exports = {"cancel_order_modal":"CancelOrderModal_cancel_order_modal__Z_Eah","content":"CancelOrderModal_content__7CmwA"};